const resources = {
  "en": {
    "publicInsights": {
      "title": "Public Insights",
      "loadFailed": "Failed to load insights",
      "noInsights": "No insights yet",
      "description": "Explore insights shared by the community.",
      "sections": {
        "feedTitle": "Community feed",
        "feedDescription": "Browse reflections that other people chose to share publicly.",
        "feedCount_one": "{{count}} insight on this page",
        "feedCount_other": "{{count}} insights on this page"
      },
      "noTags": "No tags",
      "author": "Author",
      "anonymous": "Anonymous",
      "unknown": "Unknown",
      "date": "Date",
      "viewFull": "View full insight",
      "detail": {
        "title": "Insight details",
        "description": "Read the shared insight in full and keep the context visible while you review it.",
        "summaryTitle": "Shared context",
        "summaryDescription": "Author, date, and tags for this public insight.",
        "contentTitle": "Full insight",
        "contentDescription": "The full text exactly as it was shared publicly.",
        "backToList": "Back to public insights",
        "notFoundTitle": "Insight not found",
        "notFoundDescription": "This insight is no longer available or never existed.",
        "notFoundMessage": "The requested insight could not be found."
      }
    }
  },
  "uk": {
    "publicInsights": {
      "title": "Публічні інсайти",
      "loadFailed": "Не вдалося завантажити інсайти",
      "noInsights": "Інсайтів поки немає",
      "description": "Досліджуйте інсайти, якими ділиться спільнота.",
      "sections": {
        "feedTitle": "Стрічка спільноти",
        "feedDescription": "Переглядайте роздуми, якими інші люди вирішили поділитися публічно.",
        "feedCount_one": "{{count}} інсайт на цій сторінці",
        "feedCount_few": "{{count}} інсайти на цій сторінці",
        "feedCount_many": "{{count}} інсайтів на цій сторінці",
        "feedCount_other": "{{count}} інсайта на цій сторінці"
      },
      "noTags": "Немає тегів",
      "author": "Автор",
      "anonymous": "Анонім",
      "unknown": "Невідомо",
      "date": "Дата",
      "viewFull": "Переглянути повний інсайт",
      "detail": {
        "title": "Деталі інсайту",
        "description": "Читайте публічний інсайт повністю й зберігайте весь контекст перед очима.",
        "summaryTitle": "Контекст публікації",
        "summaryDescription": "Автор, дата й теги цього публічного інсайту.",
        "contentTitle": "Повний інсайт",
        "contentDescription": "Повний текст саме в тому вигляді, у якому його опублікували.",
        "backToList": "Назад до публічних інсайтів",
        "notFoundTitle": "Інсайт не знайдено",
        "notFoundDescription": "Цей інсайт більше недоступний або ніколи не існував.",
        "notFoundMessage": "Запитаний інсайт не знайдено."
      }
    }
  }
};

export default resources;
